import React from 'react'
import { ContainerProps } from '.'

export function Container({ children, footer, style }: ContainerProps) {
  return (
    <div
      className="content-main flexbox flexbox-column flexbox-align-center transition"
      style={style}
    >
      <div className="flexbox flexbox-column boarding-modal background-shade-100 shade-05 color-mode-elevated radius-larger">
        {children}
      </div>
      {footer}
    </div>
  )
}
